import { ISpinnerDataInitialState } from "../../types/spinnerDatainterface";
import { SpinnerDataActionTypes, SpinnerDataActions } from "../actionTypes/spinnerDataActionTypes";

export const getSpinnerData = (): SpinnerDataActionTypes => ({
  type: SpinnerDataActions.GET_SPINNER_DATA,
});

export const setSpinnerData = (payload: ISpinnerDataInitialState): SpinnerDataActionTypes => ({
  type: SpinnerDataActions.SET_SPINNER_DATA,
  payload
});
